import React from 'react';
import style from './zone.module.css';
import { oneOf } from 'prop-types';

export default ZoneSizeCompensator;

ZoneSizeCompensator.propTypes = {
  mode: oneOf(['vertical'/*, 'horizontal'*/]),
};

ZoneSizeCompensator.defaultProps = {
  mode: 'vertical',
};

function ZoneSizeCompensator({ mode, children }) {
  return (
    <div className={style.compensator} data-mode={mode}>
      <div className={style.topSpacer} />
        {children}
      <div className={style.bottomSpacer} />
    </div>
  );
}
